import { render, staticRenderFns } from "./DerbyAdd.vue?vue&type=template&id=5bd25450&scoped=true&"
import script from "./DerbyAdd.vue?vue&type=script&lang=js&"
export * from "./DerbyAdd.vue?vue&type=script&lang=js&"
import style0 from "./DerbyAdd.vue?vue&type=style&index=0&id=5bd25450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd25450",
  null
  
)

export default component.exports